import { checkAddressCompleteness } from '@ssar-app/domain';
import { addressValidator as questAddrValidator } from '@ssar-app/domain/src/models/program/products/ascend-quest/validators/input-layout-validator';
import * as yup from 'yup';

export const fieldHeadersValidator = yup.array<string | undefined>(
  yup
    .string()
    .label('Field Header')
    .notRequired()
    // .test(
    //   'InvalidChars',
    //   'Invalid characters in the header name',
    //   function validCharacters(currentField) {
    //     if (currentField?.length < 1) {
    //       return true;
    //       // return this.createError({
    //       //   path: this.path,
    //       //   message: 'Field Header cannot be empty.',
    //       // });
    //     }
    //     if (/[\t,|]/.test(currentField)) {
    //       return this.createError({
    //         path: this.path,
    //         message: `Invalid characters in the header name: ${currentField}. Delimted characters such as tab, space and comma are not accepted in the field headers`,
    //       });
    //     } else {
    //       return true;
    //     }
    //   },
    // )
    .test(
      'unique',
      'Field Headers must be unique.',
      function validateUnique(currentField) {
        if (currentField?.length < 1) {
          return true;
        }
        const sameFields = this.parent.filter(
          (field?: string) => field === currentField,
        );

        return sameFields.length > 1
          ? this.createError({
              path: this.path,
              message: `Field Headers must be unique. ${currentField} mapped more than once.`,
            })
          : true;
      },
    )
    .test(
      'completeness',
      'Address Fields must be complete.',
      async function checkForAddressCompleteness(currentField) {
        const incompleteAddrFields = await checkAddressCompleteness(
          this.parent,
          questAddrValidator,
        );
        return incompleteAddrFields.indexOf(currentField) >= 0
          ? this.createError({
              path: this.path,
              message: `Fields must be complete. ${
                currentField?.split('_')?.[0]
              } fields are incomplete.`,
            })
          : true;
      },
    ),
);
